import React, { useState } from 'react';
import './style.css'; // Optional CSS file for styling

const Popup = ({ title, content }) => {
    const [showPopup, setShowPopup] = useState(false);
    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const renderContent = () => {
        return content
    }
    return (
        <>
            <p role="button" onClick={togglePopup}>
                Learn More
            </p>
            <div className={`popup ${showPopup ? 'show' : ''}`}>
                <div className="popup-inner">
                    <div className='text-justify'>{renderContent()}</div>
                    <button type="button" className='btn-border-slide' onClick={togglePopup}>Close</button>
                </div>
            </div>
        </>

    );
};

export default Popup;
